import { IconPencil } from '@tabler/icons-react';
import NSIcon from 'bricks/NSIcon/NSIcon';
import React from 'react';

export interface IReportTitleProps {
    reportName: string;
    isEditing: boolean;
    setShowUpdateReportTitleAndDescriptionModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const ReportTitle = ({ reportName, isEditing, setShowUpdateReportTitleAndDescriptionModal }: IReportTitleProps) => (
    <div>
        <span>{reportName}</span>
        {isEditing && (
            <NSIcon
                icon={IconPencil}
                size="xs"
                className="mx-1"
                style={{ fontSize: '0.8rem', cursor: 'pointer' }}
                onClick={() => setShowUpdateReportTitleAndDescriptionModal(true)}
                aria-label="Edit report name"
            />
        )}
    </div>
);

export default ReportTitle;
